// Case Study Module - Holds case study data
import { fetchData } from '../../tools.js'

// Initial state
const state = () => ({
    projectList: {},
    projectContent: {}
})

// getters
const getters = {
    projectList: (state) => {
        return state.projectList;
    },
    projectMeta: (state) => {
        if (!state.projectContent.title) return null;
        const meta = {
            title: state.projectContent.title,
            description: state.projectContent.description,
            socialDescription: state.projectContent.smDescription,
            socialTitle: state.projectContent.smTitle,

            siteName: state.projectContent.site.name,
            siteUrl: state.projectContent.site.url,
            siteSsl: state.projectContent.site.ssl,
            siteSocialImage: state.projectContent.site.defaultSMImage,
            siteSocialImageAlt: state.projectContent.site.defaultSMImageAlt,
            siteLocale: state.projectContent.site.locale,
            siteFBName: state.projectContent.site.facebookName,
            siteTwitterName: state.projectContent.site.twitterName,
            siteTwitterCardType: state.projectContent.site.twitterCardType,
            siteDefaultBannerImage: state.projectContent.site.defaultBannerImage
        }
        // Social image
        if (state.projectContent.smImage) {
            meta.socialImage = state.projectContent.smImage;
            if (state.projectContent.smImageAlt) meta.socialImageAlt = state.projectContent.smImageAlt
        }
        else if (state.projectContent.file.length > 0) {
            meta.socialImage = state.projectContent.file[0].url;
            meta.socialImageAlt = state.projectContent.file[0].name;
        }
        else if (state.projectContent.site.defaultSMImage) {
            meta.socialImage = state.projectContent.site.defaultSMImage;
            meta.socialImageAlt = state.projectContent.site.defaultSMImageAlt;
        }
        return meta;
    },
    projectContent(state) {
        if (state.projectContent === undefined) return undefined;
        return state.projectContent;
    }
}

// actions
const actions = {
    async projectList({ commit }) {
        const pList = await fetchData('/casestudylist', {}, null, 2)
        .then(function (response) {
            return response;
        });
        commit('setProjectList', pList);
    },
    async projectContent({ commit }, params) {
        const content = await fetchData('/destinationcasestudy', params.url, null, 2)
            .then(function (response) {
                return response;
            });

        commit('setProjectContent', { data: content });
    }
}

// mutations
const mutations = {
    setProjectList(state, pList) {
        // Set list data
        state.projectList = pList;
    },
    setProjectContent(state, params) {
        // Set detail data
        state.projectContent = params.data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}